import { User as FirebaseUser } from '@angular/fire/auth';

export interface AuthUserClaims {
	user_ref: string;
	name: string;
	given_name?: string;
	family_name?: string;
	mail?: string;
	picture?: string;
	company?: string;
	country?: string;
	department?: string;
	office?: string;
	manager_name?: string;
	manager_ref?: string;
}

export class AuthUser {
	public get displayName(): string {
		return [this.firstName, this.lastName].join(' ');
	}

	constructor(
		public readonly firebaseUser: FirebaseUser,
		public id: string,
		public userRef: string,
		public firstName: string,
		public lastName: string,
		public mail: string,
		public picture?: string,
		public company?: string,
		public country?: string,
		public department?: string,
		public office?: string,
		public managerName?: string,
		public managerRef?: string
	) {}

	public static build(user: FirebaseUser, claims: AuthUserClaims): AuthUser {
		const firstName = claims.given_name ?? claims.name?.split(' ', 2)[0] ?? '';
		const lastName = claims.family_name ?? claims.name?.split(' ', 2)[1] ?? '';
		return new AuthUser(
			user,
			user.uid,
			claims.user_ref,
			firstName,
			lastName,
			claims.mail ?? '',
			claims.picture,
			claims.company,
			claims.country,
			claims.department,
			claims.office,
			claims.manager_name,
			claims.manager_ref
		);
	}
}
